export function round(x, decimals = 2) {
  return Math.round(x * Math.pow(10, decimals)) / Math.pow(10, decimals)
}

export const OZT_TO_GR_RATE = 31.1034768
